import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { DependenciaModel } from 'src/app/models/dependencia.model';

@Component({
  selector: 'app-generar-reportes',
  templateUrl: './generar-reporte.component.html',
  styleUrls: ['./generar-reporte.component.scss']
})

export class GenerarReporteComponent implements OnInit {

  // @Input() public dependencia: DependenciaModel[];
  public filtroReporte: string;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService) {
  }

  ngOnInit() {
    this.filtroReporte = '1';
  }

  /**
   * Método para regresar a la pantalla principal
   */
  public regresarListado() {
    this.router.navigate(['/main']);
  }

  /**
   * Método de control de Excepciones
   * @param error mensaje saliente respecto al error ocurrido
   * @param err   Tipo de error
   */
  cathException(error, err) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }
}
